<template>
  <router-view></router-view>
</template>

<script>
    export default {
      name: "product",
      data() {
        return {

        }
      },
      methods: {

      },
      mounted() {
        let path = this.$route.path;;
        let saleToken = this.$route.query.saleToken;

        if (path == '/product' || path == '/product/') {
          if (!this.$$.isValidObj(saleToken)) {
            this.$router.push({name: 'index'});
            return;
          }

          this.$router.push({name: 'introductionPage', query: {saleToken: saleToken}});
        }
      }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product.vue